import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { fieldsClient } from '../../utils/apollo/api'
import { usePromiseQuery } from '../../utils/apollo/_helpers/promiseQuery'
import Select from '../../packages/kiti/components/form/Select'
import { get } from 'lodash'

const ORIGIN_KEYS = {
  location: 'Local',
  person: 'Pessoa'
}

const QUERY = gql`
  query Fields($search: String, $page: Int, $filter: FieldFilter) {
    fields(search: $search, page: $page, sort: { field: NAME, type: ASC }, filter: $filter) {
      id
      name
      origin
    }
  }
`

const useFieldsLoader = (filter, useOriginAsLabel) => {
  const query = usePromiseQuery(QUERY, { client: fieldsClient })
  return (search, page = 1) => {
    return query({ search, page, filter })
      ?.then(pathOr([], ['data', 'fields']))
      .then(fields =>
        useOriginAsLabel ? fields.map(field => ({ ...field, originLabel: ORIGIN_KEYS[field?.origin] })) : fields
      )
  }
}

const FieldSelect = ({ onChange, value, filter, useOriginAsLabel = false, ...props }) => {
  const getOptions = useFieldsLoader(filter, useOriginAsLabel)

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      descriptionField="originLabel"
      {...props}
    />
  )
}

export default FieldSelect
